import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLoading, getRoutinesLoading } from "selectors/commonSelectors";
import { getSelectedIgAccount } from "selectors/hashtagFeedSelectors";
import AccountCombobox from "./AccountCombobox";

import {
  HASHTAG_FEED_GET_RECENT_HASHTAGS_ROUTINE,
  SELECT_IG_ACCOUNT_ROUTINE,
} from "constants/ActionTypes";
import { selectIgAccount } from "actions/sourceMedia";
import { AccountType } from "shared/types/accounts";

interface SelectFeedAccountProps {
  onClick: (account: AccountType) => void;
  accounts: AccountType[];
}

const SelectFeedAccount = ({
  onClick,
  accounts,
}: SelectFeedAccountProps): JSX.Element => {
  const dispatch = useDispatch();
  const selectedIgAccount = useSelector(
    getSelectedIgAccount
  ) as AccountType | null;
  const [selectedAccount, setSelectedAccount] = useState<AccountType | null>(
    selectedIgAccount
  );
  const loading = useSelector(getLoading);
  const loadingHashtags = useSelector((state: any) =>
    getRoutinesLoading(state, [
      SELECT_IG_ACCOUNT_ROUTINE,
      HASHTAG_FEED_GET_RECENT_HASHTAGS_ROUTINE,
    ])
  );
  const handleChange = (account: AccountType): void => {
    setSelectedAccount(account);
    dispatch(selectIgAccount(account._id));
    onClick(account);
  };

  return (
    <div className="space-y-2">
      <AccountCombobox
        accounts={accounts}
        onSelect={handleChange}
        selectedAccountId={selectedAccount?._id}
      />
      {!loading && accounts.length === 0 && (
        <div className="mt-3 px-3 py-2.5 bg-red-50 border border-red-200 rounded-lg">
          <p className="text-sm text-red-700 font-medium">
            Update your Instagram permissions to search and save posts you were
            tagged in.
          </p>
        </div>
      )}
      {loadingHashtags && (
        <div className="flex items-center gap-2 py-2 text-neutral-500 mt-2">
          <i className="fa-solid fa-spinner fa-spin text-sm" />
          <span className="text-sm">Loading...</span>
        </div>
      )}
    </div>
  );
};

export default SelectFeedAccount;
